import axiosInstanceApiKong from 'config/apiServiceApiGateway'
import { Put } from 'config/apiServiceConfig'

export type GetDirectPutawayResponseType = {
  data: {
    id: number
    inbound_date: number
    status: string
    location: {
      location_id: number
      location_name: string
      location_type: string
    }
    package_id: {
      id: number
      package_label: string
      created_date: string
      created_at: string
      created_by: string
    }
    product_exp_date: string
    product: {
      product_id: number
      product_sku_no: string
      product_name: string
      uom: string
      primary_category: {
        id: number
        name: string
      }
    }
    rack: {
      rack_id: number
      rack_name: string
      rack_position: null | number
    } | null
    staff: {
      staff_id: number
      staff_full_name: string
      staff_phone_number: string
    } | null
    quantity: number
    start_at: number | null
    end_at: number | null
    action: string[]
    created_at: number
    created_by: string
    updated_at: string | null
    updated_by: string | null
    device: string
    carton_qty: number
    is_direct_pf: boolean
  }[]
  pagination: {
    sort: string
    direction: string
    page_size: number
    page_index: number
    number_of_elements: number
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export type GetDirectPutawayRequestType = {
  params: {
    page_index?: number
    page_size?: number
    sort?: string
    direction?: string
    location_ids?: string
    sku_number?: string
    package_label?: string
    product_category_id?: number
    status?: string
    inbound_date?: string
  }
}

export type GetEligibleRacksResponseType = {
  data: {
    active: boolean
    id: number
    rackName: string
  }[]
}

export type GetStaffResponseType = {
  data: {
    staffId: number
    staffFullName: string
    staffPhoneNumber: string
  }
}

export type GetStaffResponseKongType = {
  data: {
    staff: {
      staff_id: number
      staff_full_name: string
      staff_phone_number: string
    }
  }
}

export type UpdatePutAwayPayloadType = {
  staff_id: number
  rack_id?: number
}

export type PostValidatePoCompleteResponseType = {
  data: true | null
  error: {
    status: false
    message: ''
    code: 0
  }
  message: ''
}

export const getDirectPutaway = (qsParam: string) =>
  axiosInstanceApiKong.Get<GetDirectPutawayResponseType, true>({
    url: `/wms/internal/v1/putaway-tasks?${qsParam}`,
  })

export const completePutAway = (putawayTaskID: number, data: UpdatePutAwayPayloadType) =>
  Put({
    url: `/api/wms/:version/putaway-task/${putawayTaskID}/complete`,
    version: 'v1',
    data,
  })

export const updatePutAway = (putawayTaskID: number, data: UpdatePutAwayPayloadType) =>
  Put({
    url: `/api/wms/:version/putaway-task/${putawayTaskID}`,
    version: 'v1',
    data,
  })

export const resetPutaway = (putawayTaskID: number) =>
  Put({
    url: `/api/wms/:version/putaway-task/${putawayTaskID}/reset`,
    version: 'v1',
  })

export const getStaffByPhone = (phone_number: string) =>
  axiosInstanceApiKong.Post<GetStaffResponseKongType, true>({
    url: '/staff-management/internal/v1/staff/get-by-phone-number',
    data: {
      phone_number,
    },
  })
